<template>
	<v-row>
		<v-col cols="12">
			<h2 v-html="title"></h2>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: "section-header",
	props: {
		title: {
			type: String,
			required: true
		}
	}
}
</script>

<style scoped>
h2 {
	padding-bottom: 10px;
	border-bottom: 1px solid #eaeaea;
}
</style>